// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"OverlayTrigger_tooltip__3DhB-","copy":"OverlayTrigger_copy__1e_Qw"};